import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';
import parseJwt from 'utils/parsers/parseJwt';

const getToken = nullBind(getAnyOrNull, 'response.slave_token');
const getPrimary = nullBind(getAnyOrNull, 'response.is_master');
const getRole = nullBind(getAnyOrNull, 'response.permission_type');
const getName = nullBind(getAnyOrNull, 'response.username');
const getStylistId = nullBind(getAnyOrNull, 'response.stylist_id');
const getCustomerSupport = nullBind(getAnyOrNull, 'response.is_customer_support');

const reducePinSuccess = (state, data) => {
  const lockToken = getToken(data);
  return {
    ...state,
    latest: { tag: 'PIN', now: Date.now(), event: null },
    lockToken,
    locked: !lockToken,
    parsedToken: parseJwt(lockToken),
    userPrimary: getPrimary(data),
    userName: getName(data),
    userRole: getRole(data),
    stylistId: getStylistId(data),
    isCustomerSupport: getCustomerSupport(data),
  };
};

// noinspection JSUnusedGlobalSymbols
export default reducePinSuccess;
